(()=>{
  const setup=()=>{
    const header=document.getElementById('shopify-section-jb-header');
    if(!header||header.dataset.compactReady)return;
    header.dataset.compactReady='true';
    const mobile=window.matchMedia('(max-width:999px)');
    let pending=false;
    const update=()=>{
      pending=false;
      if(!header.isConnected){window.removeEventListener('scroll',schedule);mobile.removeEventListener('change',schedule);return;}
      const compact=mobile.matches&&(window.scrollY>160||(header.classList.contains('jb-header-compact')&&window.scrollY>24));
      if(compact!==header.classList.contains('jb-header-compact'))header.classList.toggle('jb-header-compact',compact);
    };
    const schedule=()=>{if(!pending){pending=true;window.requestAnimationFrame(update);}};
    window.addEventListener('scroll',schedule,{passive:true});
    mobile.addEventListener('change',schedule);
    window.addEventListener('pageshow',schedule);
    update();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();
